/* eslint-disable no-nested-ternary */
import React from 'react';
import { Card } from 'react-bootstrap';
import ReactHtmlParser from 'react-html-parser';
import { isEmpty } from 'lodash-es';
import PropTypes from 'prop-types';

import { ReportPersonaltySpiderChart } from './ReportPersonalitySpiderChart';

export function ReportTeamPersonalityChartSection({ respondent, section }) {
  if (!respondent.report?.Agreeableness?.Agreeableness?.teamPercentiles?.length) {
    return null;
  }

  const getScore = (trait) => {
    const score = {};
    let mainScore = null;
    let avgTeamScore = null;
    let teamScore = null;
    Object.entries(trait).forEach(([, value]) => {
      if (!value.description) {
        mainScore = value.caption;
        avgTeamScore = Math.round(value.avgTeamPercentile);
        teamScore = value.teamPercentiles;
      }
      score[value.caption] = Math.round(value.percentile);
    });
    return {
      score, mainScore, avgTeamScore, teamScore,
    };
  };
  const plotTeamReport = (report) => {
    const scores = {};
    const avgTeamScores = {};
    const teamScores = {};
    Object.entries(report).forEach(([, bfiValue]) => {
      const {
        score, mainScore, avgTeamScore, teamScore,
      } = getScore(bfiValue);
      scores[mainScore] = score[mainScore];
      if (avgTeamScore) {
        avgTeamScores[mainScore] = avgTeamScore;
        teamScores[mainScore] = teamScore;
      }
    });
    if (isEmpty(avgTeamScores)) {
      return null;
    }

    return (
      <Card key="report-section-chart-team-personality" className="pagebreak py-3 my-3">
        <Card.Body>
          <div className="m-3 p-3">
            <h2>Collective Team Personality</h2>
          </div>
          {section.sections.map((subSection) => (
            <div className="m-3 p-3" key={subSection.key}>
              <div>{ReactHtmlParser(subSection.content)}</div>
            </div>
          ))}
          <div className="mx-5">
            <ReportPersonaltySpiderChart
              scores={scores}
              teamScores={teamScores}
            />
          </div>
        </Card.Body>
      </Card>
    );
  };

  return (
    <>
      {plotTeamReport(respondent.report)}
    </>
  );
}

ReportTeamPersonalityChartSection.propTypes = {
  section: PropTypes.shape({
    key: PropTypes.string,
    type: PropTypes.string,
    title: PropTypes.string,
    sections: PropTypes.arrayOf(PropTypes.shape({
      key: PropTypes.string,
      title: PropTypes.string,
      content: PropTypes.string,
    })),
  }),
  respondent: PropTypes.shape({
    report: PropTypes.shape({
      Neuroticism: PropTypes.shape({
        Anixiety: PropTypes.shape({
          percentile: PropTypes.number,
          description: PropTypes.string,
          caption: PropTypes.string,
        }),
        Anger: PropTypes.shape({
          percentile: PropTypes.number,
          description: PropTypes.string,
          caption: PropTypes.string,
        }),
        Depression: PropTypes.shape({
          percentile: PropTypes.number,
          description: PropTypes.string,
          caption: PropTypes.string,
        }),
        SelfConsciousness: PropTypes.shape({
          percentile: PropTypes.number,
          description: PropTypes.string,
          caption: PropTypes.string,
        }),
        Immoderation: PropTypes.shape({
          percentile: PropTypes.number,
          description: PropTypes.string,
          caption: PropTypes.string,
        }),
        Vulnerability: PropTypes.shape({
          percentile: PropTypes.number,
          description: PropTypes.string,
          caption: PropTypes.string,
        }),
        Neuroticism: PropTypes.shape({
          percentile: PropTypes.number,
          description: PropTypes.string,
          caption: PropTypes.string,
        }),
      }),
      Extraversion: PropTypes.shape({
        Friendliness: PropTypes.shape({
          percentile: PropTypes.number,
          description: PropTypes.string,
          caption: PropTypes.string,
        }),
        Gregariousness: PropTypes.shape({
          percentile: PropTypes.number,
          description: PropTypes.string,
          caption: PropTypes.string,
        }),
        Assertiveness: PropTypes.shape({
          percentile: PropTypes.number,
          description: PropTypes.string,
          caption: PropTypes.string,
        }),
        ActivityLevel: PropTypes.shape({
          percentile: PropTypes.number,
          description: PropTypes.string,
          caption: PropTypes.string,
        }),
        ExcitementSeeking: PropTypes.shape({
          percentile: PropTypes.number,
          description: PropTypes.string,
          caption: PropTypes.string,
        }),
        Cheerfulness: PropTypes.shape({
          percentile: PropTypes.number,
          description: PropTypes.string,
          caption: PropTypes.string,
        }),
        Extraversion: PropTypes.shape({
          percentile: PropTypes.number,
          description: PropTypes.string,
          caption: PropTypes.string,
        }),
      }),
      Openness: PropTypes.shape({
        Imagination: PropTypes.shape({
          percentile: PropTypes.number,
          description: PropTypes.string,
          caption: PropTypes.string,
        }),
        ArtisticInterests: PropTypes.shape({
          percentile: PropTypes.number,
          description: PropTypes.string,
          caption: PropTypes.string,
        }),
        Emotionality: PropTypes.shape({
          percentile: PropTypes.number,
          description: PropTypes.string,
          caption: PropTypes.string,
        }),
        Adventureousness: PropTypes.shape({
          percentile: PropTypes.number,
          description: PropTypes.string,
          caption: PropTypes.string,
        }),
        Intellect: PropTypes.shape({
          percentile: PropTypes.number,
          description: PropTypes.string,
          caption: PropTypes.string,
        }),
        Liberalism: PropTypes.shape({
          percentile: PropTypes.number,
          description: PropTypes.string,
          caption: PropTypes.string,
        }),
        Openness: PropTypes.shape({
          percentile: PropTypes.number,
          description: PropTypes.string,
          caption: PropTypes.string,
        }),
      }),
      Agreeableness: PropTypes.shape({
        Morality: PropTypes.shape({
          percentile: PropTypes.number,
          description: PropTypes.string,
          caption: PropTypes.string,
        }),
        Altruism: PropTypes.shape({
          percentile: PropTypes.number,
          description: PropTypes.string,
          caption: PropTypes.string,
        }),
        Cooperation: PropTypes.shape({
          percentile: PropTypes.number,
          description: PropTypes.string,
          caption: PropTypes.string,
        }),
        Modesty: PropTypes.shape({
          percentile: PropTypes.number,
          description: PropTypes.string,
          caption: PropTypes.string,
        }),
        Sympathy: PropTypes.shape({
          percentile: PropTypes.number,
          description: PropTypes.string,
          caption: PropTypes.string,
        }),
        Agreeableness: PropTypes.shape({
          percentile: PropTypes.number,
          description: PropTypes.string,
          caption: PropTypes.string,
          teamPercentiles: PropTypes.array,
        }),
      }),
      Conscientiousness: PropTypes.shape({
        SelfEfficicacy: PropTypes.shape({
          percentile: PropTypes.number,
          description: PropTypes.string,
          caption: PropTypes.string,
        }),
        Orderliness: PropTypes.shape({
          percentile: PropTypes.number,
          description: PropTypes.string,
          caption: PropTypes.string,
        }),
        Dutifulness: PropTypes.shape({
          percentile: PropTypes.number,
          description: PropTypes.string,
          caption: PropTypes.string,
        }),
        AchievementStriving: PropTypes.shape({
          percentile: PropTypes.number,
          description: PropTypes.string,
          caption: PropTypes.string,
        }),
        SelfDiscipline: PropTypes.shape({
          percentile: PropTypes.number,
          description: PropTypes.string,
          caption: PropTypes.string,
        }),
        Cautiousness: PropTypes.shape({
          percentile: PropTypes.number,
          description: PropTypes.string,
          caption: PropTypes.string,
        }),
        Conscientiousness: PropTypes.shape({
          percentile: PropTypes.number,
          description: PropTypes.string,
          caption: PropTypes.string,
        }),
      }),
      status: PropTypes.string,
      surveyId: PropTypes.string,
      templateId: PropTypes.string,
      updatedAt: PropTypes.string,
      respondentId: PropTypes.string,
    }),
  }),
};

ReportTeamPersonalityChartSection.defaultProps = {
  respondent: { report: null },
  section: {},
};
